import React, { useEffect } from "react";
import { TextField } from "@material-ui/core";
import { Form, Field } from "react-final-form";
import { IntroText, FormActionDrawer } from "../../../components";
import createDecorator from "final-form-focus";
import { useHeader } from "../../../contexts";
import { string, object } from "yup";
import { useYupValidation } from "../../../hooks";
import { useTranslation } from "react-i18next";

const focusOnErrors = createDecorator();

const validationSchema = object({
  full_name: string()
    .required()
    .trim()
    .label("Full Name")
});

const ScheduleInfluenzaConsent = ({
  setDrawerClearance,
  updateScheduleData,
  scheduleData,
  isSubmitting
}) => {
  const { t } = useTranslation();
  const { setTitle } = useHeader();

  useEffect(() => {
    setTitle(t("schedule.influenza_consent.title"));
  }, []);

  const { validate } = useYupValidation();

  const validateForm = async data => {
    const errors = await validate(validationSchema)(data);

    if (errors) return errors;

    updateScheduleData({ influenzaConsent: data });
  };

  return (
    <>
      <Form
        onSubmit={validateForm}
        initialValues={
          scheduleData.influenzaConsent || scheduleData.consent || {}
        }
        decorators={[focusOnErrors]}
        render={({ handleSubmit, submitErrors: errors = {} }) => (
          <form
            data-cy="schedule-screen-influenza-consent"
            onSubmit={handleSubmit}
          >
            <IntroText>{t("schedule.influenza_consent.intro_text")}</IntroText>
            <Field
              name="full_name"
              render={({ input }) => (
                <TextField
                  {...input}
                  label={t("schedule.influenza_consent.form.full_name.label")}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  error={!!errors.full_name}
                  helperText={errors.full_name}
                  inputProps={{
                    "data-lpignore": "true",
                    "data-cy": "input-full_name"
                  }}
                />
              )}
            />
            <FormActionDrawer
              setDrawerClearance={setDrawerClearance}
              loading={isSubmitting}
            />
          </form>
        )}
      />
    </>
  );
};

export { ScheduleInfluenzaConsent };
